import axios from "axios";
import { store } from "@/store/index";

export function axiosDefault(config) {
  const instance = axios.create({
    baseURL: config.WebApiUrl
  });

  return instance;
}

export function axiosWAuth(config) {
  const instance = axios.create({
    baseURL: config.WebApiUrl,
    withCredentials: true
  });

  //Add Authorization to request header
  instance.interceptors.request.use(
    config => {
      // Check if the application is in maintenance mode and reject request
      if (store.getters.getMaintenanceStatus) {
        return Promise.reject(
          new axios.Cancel("Application is in maintenance mode")
        );
      }
      config.headers.common = {
        ...config.headers.common,
        // This is a fallback if auth cookie is disabled
        Authorization: "Bearer " + store.getters.getAccessToken
      };
      return config;
    },
    error => Promise.reject(error)
  );

  //Check responses for 401 response (reach out to refresh token here when we get refresh token)
  instance.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      if (error.response.status === 401) {
        return new Promise((resolve, reject) => {
          const currentUrl = window.location.href;
          store.dispatch("logout");
          window.location.href =
            config.WebCaatAuthWebUrl +
            "?returnUrl=" +
            encodeURIComponent(currentUrl);
          reject(error);
        });
      } else if (
        error.response.status === 403 &&
        error.response.data.errorCode === "NON_MMS_USER"
      ) {
        window.location.href = `${window.location.origin}/maintenance`;
        console.error("Specific 403 error:", error.response.data.errorCode);
      } else {
        return new Promise((resolve, reject) => reject(error));
      }
    }
  );

  return instance;
}
